function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from "react";
import PropTypes from "prop-types";
import withBus from "../Bus";
import Snackbar from "./Snackbar";
let SnackbarQueuer = class SnackbarQueuer extends Component {
    componentDidMount() {
        const { eventBus  } = this.props;
        eventBus.on("snackbar", this.addToQueue);
    }
    componentWillUnmount() {
        const { eventBus  } = this.props;
        eventBus.removeListener("snackbar", this.addToQueue);
    }
    handleExited() {
        this.queue.shift();
        this.updateQueueSize(()=>{
            const { queueSize  } = this.state;
            if (queueSize) this.showSnackbar();
            else this.init = false;
        });
    }
    handleRequestClose() {
        this.setState({
            open: false
        });
    }
    addToQueue(snackbar) {
        this.queue.push(snackbar);
        this.updateQueueSize();
        if (!this.init) {
            this.init = true;
            this.showSnackbar();
        }
    }
    showSnackbar() {
        this.setState({
            open: true
        });
    }
    updateQueueSize(cb) {
        this.setState({
            queueSize: this.queue.length
        }, cb);
    }
    render() {
        const { open  } = this.state;
        const snackbar = this.queue[0] || {};
        return /*#__PURE__*/ _jsx(Snackbar, {
            onExited: this.handleExited,
            open: open,
            message: snackbar.message,
            actionText: snackbar.actionText,
            onRequestClose: this.handleRequestClose,
            onActionClick: snackbar.onAction
        });
    }
    constructor(){
        super();
        this.handleRequestClose = this.handleRequestClose.bind(this);
        this.addToQueue = this.addToQueue.bind(this);
        this.handleExited = this.handleExited.bind(this);
        this.state = {
            open: false,
            queueSize: 0
        };
        this.queue = [];
    }
};
_defineProperty(SnackbarQueuer, "propTypes", {
    eventBus: PropTypes.shape({
        on: PropTypes.func,
        removeListener: PropTypes.func
    })
});
export default withBus(SnackbarQueuer);
